import Swal from 'sweetalert2';
import { b64toBlob } from '~core';
import { getState } from '~src/state';
import { cleanBase64 } from '~src/utils';
import { imageObjectToDataURL } from '~core/image';

export default async function prepareImageForEditing(
  imageObject,
  handleSwal = true
) {
  const hasOpacity =
    parseFloat(
      imageObject._magicFrame
        ? imageObject._magicFrame.opacity
        : imageObject.opacity
    ) < 1;
  const isFlipped = imageObject.flipX || imageObject.flipY;
  const isErased = typeof imageObject.eraser !== 'undefined';
  const hasFilters = imageObject.filters.length > 0;

  const needsUploads = hasOpacity || isFlipped || isErased || hasFilters;

  if (needsUploads) {
    if (handleSwal) {
      Swal.fire({
        text: "Preparazione dell'ambiente di lavoro...",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    const imageBase64 = cleanBase64(await imageObjectToDataURL(imageObject));
    const ephemeralUploader = getState('uploader.ephemeral');
    const blob = b64toBlob(imageBase64.base64, imageBase64.contentType);

    ephemeralUploader.addFile({
      type: blob.type,
      data: blob,
    });

    const responseUpload = await ephemeralUploader.upload();

    ephemeralUploader.cancelAll();

    const imageUrl = `${process.env.EDGE_RESIZER}${
      new URL(responseUpload.successful[0].uploadURL).pathname
    }`;

    if (handleSwal) {
      Swal.close();
    }

    return imageUrl;
  }

  return (
    imageObject.getSrc() ||
    imageObject._element.src ||
    imageObject._element.currentSrc
  );
}
